// lib/supabase.js
import { createClientComponentClient } from "@supabase/auth-helpers-nextjs";

// Cliente para componentes do lado do cliente (App Router)
// Gerencia cookies automaticamente para manter a sessão
export const supabase = createClientComponentClient();
